import { Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ControlContainer, NgForm, NgModelGroup } from '@angular/forms';
import * as _ from 'lodash';

@Component({
  selector: 'combo-tipo-sangue',
  templateUrl: './combo-tipo-sangue.component.html',
  styleUrls: ['./combo-tipo-sangue.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm },
                  { provide: ControlContainer, useExisting: forwardRef(() => NgModelGroup) }],
})
export class ComboTipoSangueComponent implements OnInit {

  @ViewChild('comboTipoSangue', {static: false}) comboTipoSangue;

  @Input() showDisplayId;
  @Input() obrigatorio;
  @Input() selecionado;
  @Input() desabilitado;

  @Output() valorChange = new EventEmitter();

  dados = [];
  data: any = {};

  constructor() {
  }

  ngOnInit(): void {
    this.data = Date.now();

    // Dados estáticos dos tipos sanguíneos
    this.dados = [
      { id: 1, tipo: 'A+' },
      { id: 2, tipo: 'A-' },
      { id: 3, tipo: 'B+' },
      { id: 4, tipo: 'B-' },
      { id: 5, tipo: 'AB+' },
      { id: 6, tipo: 'AB-' },
      { id: 7, tipo: 'O+' },
      { id: 8, tipo: 'O-' }
    ];

    this.preencherCombo();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.preencherCombo();
  }

  private preencherCombo(){
    if (this.selecionado && this.dados.length) {
      this.selecionado = _.find(this.dados, { tipo: this.selecionado});
    }
  }

  onValorChange(registro: any) {
    this.valorChange.emit(registro);
    this.preencherCombo();
  }

}
